import TagManager from "react-gtm-module";

const triggerGTM = (event, button_id, additionalProperties) => {
    const preferences = JSON.parse(localStorage.getItem('cookie_preferences'));
    if (!preferences || preferences['analytics'] == false) return;
    const tagManagerArgs = {
        dataLayer: {
            event: event,
            button_id: button_id,
            ...additionalProperties
        },
    };
    TagManager.dataLayer(tagManagerArgs);
};

const triggerGTMMEtaPixel = () =>{
    const preferences = JSON.parse(localStorage.getItem('cookie_preferences'));
    const ad_storage_granted = preferences && preferences['marketing'] == true
    const metaPixelArgs = {
        dataLayer: {
            event: 'meta_pixel_event',
            ad_storage: ad_storage_granted ? 'granted' : 'denied',
        },
    };
    // alert(ad_storage_granted);
    TagManager.dataLayer(metaPixelArgs);
}

export {triggerGTM, triggerGTMMEtaPixel};